import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  changePayment,
  changePaymentMethod,
  fetchOrderDetails,
} from "../../Services/OrderService";
import { Spinner } from "react-bootstrap";
import { format } from "date-fns";

export const PaymentFail = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [failLoading, setFailLoading] = React.useState(false);
  const [order, setOrder] = React.useState();
  const [orderLoading, setOrderLoading] = React.useState(false);

  React.useEffect(() => {
    setOrderLoading(true);
    console.log(params.get("id"));
    fetchOrderDetails(params.get("id")).then(
      (res) => {
        setOrderLoading(false);
        setOrder(res.data);
      },
      (er) => {
        console.warn(er, "error on order fetch");
      }
    );
  }, [params]);

  const change = (status) => {
    if (!loading) {
      const id = params.get("id");
      if (status === "pending") {
        setLoading(true);
        changePayment(id).then(
          (res) => {
            setLoading(false);
            toast.success(res.message);
            navigate(`/app/order-placed/${id}`, { replace: true });
          },
          (er) => {
            setLoading(false);
            if (er && er.errors && er.errors.length)
              er.errors.forEach((x) => toast.error(x.message));
            else
              toast.error(
                "Something went wrong while changing payment method..."
              );
          }
        );
      } else {
        setFailLoading(true);
        changePaymentMethod(id, status).then(
          (res) => {
            setFailLoading(false);
            toast.success(res.message);
            navigate("/", { replace: true });
          },
          (er) => {
            setFailLoading(false);
            if (er && er.errors && er.errors.length)
              er.errors.forEach((x) => toast.error(x.message));
            else
              toast.error(
                "Something went wrong while changing payment method..."
              );
          }
        );
      }
    }
  };

  return (
    <Modal
      show={true}
      // onHide={() => setIsOpen(false)}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Body>
        <div className="px-3">
          <div className="d-flex justify-content-center">
            <img src={process.env.PUBLIC_URL + "/assets/images/warning.png"} width={50} alt="" />
          </div>
          <h4 className="fw-bold text-center my-3">
            Do you agree with this digital payment order failure?
          </h4>
          <h6 className="fw-normal text-center mb-4">
            If you do not continue with your order payment system then your
            order will be failed . You can switch your order to Cash On Delivery
            now.
          </h6>

          {orderLoading ? (
            <div className="col-12 text-center">
              <Spinner variant="primary" size="sm" />
            </div>
          ) : (
            <>
              <h6 className="fw-normal mb-0">
                <b>Order ID:</b> {order?.id},
              </h6>
              <h6 className="fw-normal mb-0">
                <b>Order Date:</b>{" "}
                {order?.created_at && format(order?.created_at, "do MMM, yyyy")}
                ,
              </h6>
              <h6 className="fw-normal mb-0">
                <b>Order Amount:</b> {order?.order_amount}
              </h6>
            </>
          )}
        </div>
        <Button
          variant="primary"
          className="w-100 mt-2 fw-semibold text-white"
          onClick={() => change("pending")}
          disabled={loading || failLoading}
        >
          {loading ? <Spinner size="sm" className="text-white me-2" /> : null}
          Switch to Cash on Delivery
        </Button>
        <Button
          variant="outline-danger"
          className="w-100 mt-2 fw-semibold"
          onClick={() => change("failed")}
          disabled={failLoading || loading}
        >
          {failLoading ? <Spinner size="sm" className="me-2" /> : null}
          Continue with Order Fail
        </Button>
      </Modal.Body>
    </Modal>
  );
};
